import constants from '@/utilities/constants';
import { browserStorageSetItem } from '@/utilities/browser-storage.util';

export default {
  computed: {
    defaultTabName() {
      return this.$store.getters.getDefaultTabName;
    },
    redirectRoute() {
      return this.$store.getters.getRedirectRouteAfterLogin;
    },
  },

  methods: {
    tryFetchingUser() {
      return this.$store.dispatch('loadUser').then(({ user }) => {
        this.setUser(user);
        const localCurrentTeamId = localStorage.getItem('currentTeamId');
        const teamIndex = user.teams.findIndex((t) => t.id === localCurrentTeamId);
        const route = { ...this.redirectRoute };

        if (Object.keys(route).length) {
          if (route.trusted) {
            browserStorageSetItem('redirectRouteAfterLogin', route);
            // Check if the user has any workspaces
            if (user.teams.length === 0) {
              this.$router.push({ name: constants.routeNames.onboardingInfo });
              return;
            }
            this.clearPostLoginState();
            this.$router.push(route.fullPath);
            return;
          }
          const redirectTeam = user.teams.find((t) => t.sub_domain === route.params.team_subdomain);
          if (redirectTeam) {
            this.setTeam(redirectTeam);
            this.$router.push(route);
          } else {
            this.getPendingInvities(user);
          }
        } else if (teamIndex !== -1) {
          if (user.teams[teamIndex]) {
            this.setTeam(user.teams[teamIndex]);
            this.$router.push(this.defaultTabName);
          } else {
            this.getPendingInvities(user);
          }
        } else {
          this.getPendingInvities(user);
        }
        this.clearPostLoginState();
      });
    },
    clearPostLoginState() {
      this.$store.dispatch('setOnboardingErrorMessage', '');
      this.$store.dispatch('setRedirectRouteAfterLogin', {});
    },
    setUser(user) {
      this.$store.dispatch('setLoggedIn');
      this.$store.dispatch('setUser', user);
      this.$store.dispatch('setOnboardingUserID', user.id);
    },
    setTeam(team) {
      this.$store.dispatch('setCurrentTeamId', team.id);
      this.$store.dispatch('setTeamSubDomain', team.sub_domain);
      const key = `${team.id}-currentProjectId`;
      const currentProjectId = localStorage.getItem(key);
      if (currentProjectId) {
        this.$store.dispatch('setCurrentProjectId', currentProjectId);
      }
    },
    getPendingInvities(user) {
      this.$store
        .dispatch('getPendingInvities')
        .then((data) => {
          if (data.pending_invites.length === 0 && user.teams.length === 1) {
            this.setTeam(user.teams[0]);
            this.$router.push(this.defaultTabName);
          } else if (data.pending_invites.length || user.teams.length) {
            this.$router.push({ name: constants.routeNames.workspaces });
          } else {
            this.$store.dispatch('setOnboardingErrorMessage', '');
            this.$router.push({ name: constants.routeNames.onboardingInfo });
          }
        })
        .catch(() => {
          if (user.teams && user.teams.length) {
            this.$router.push({ name: constants.routeNames.workspaces });
            return;
          }
          this.$router.push({ name: constants.routeNames.onboardingInfo });
        });
    },
    scrollToBtm() {
      const container = document.querySelector('.onboarding_container');
      if (!container) return;
      container.scrollTop = container.scrollHeight;
    },
  },
};
